import { render, staticRenderFns } from "./UserCardUI.vue?vue&type=template&id=0233071e&lang=pug&"
import script from "./UserCardUI.vue?vue&type=script&lang=js&"
export * from "./UserCardUI.vue?vue&type=script&lang=js&"
import style0 from "./UserCardUI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports